<div class="page-content">
    <p-panel header="OO8 Connectors management" class="no-x-padding">
        <app-oo8-connector-crud></app-oo8-connector-crud>
    </p-panel>
</div>
